module.exports = __webpack_public_path__ + "img/1223_5.731dfdc4.png";